export default __webpack_public_path__ + "static/media/97.1466dbca.png";